import { Chip, Stack, Typography } from "@mui/material";
import { EdProduct } from "../../EdOptions";
import { MedicationIcon } from "src/shared/components/MedicationIcon";
import { theme } from "src/assets/theme";
import { useCallback, useMemo } from "react";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";

interface Props {
  product: EdProduct;
}

const Option = ({ product }: Props) => {
  const isMobile = useIsMobile();
  const { submitAnswer, nextQuestion } = useSubmitAnswers();
  const { t } = useTranslation();

  const handleSelect = useCallback(() => {
    submitAnswer([product.value], undefined, true);
    nextQuestion({ variant: product.value });
  }, [nextQuestion, product.value, submitAnswer]);

  const tags = useMemo(
    () => (isMobile && product.mobileTags ? product.mobileTags : product.tags),
    [isMobile, product.mobileTags, product.tags],
  );

  return (
    <Stack
      onClick={handleSelect}
      sx={{
        border: "1px solid #000000",
        borderRadius: "30px",
        "&:hover": {
          borderColor: theme.palette.primary.main,
          borderWidth: "2px",
        },
        cursor: "pointer",
      }}
      p={"20px"}
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Stack>
          <Typography>{t(product.medication)}</Typography>
          <Typography variant="h5" color="#0E888A">
            {t(product.name, product.name)}
          </Typography>
        </Stack>
        <MedicationIcon name={product.medicationValue} slug="ed-ot" />
      </Stack>
      <Stack direction={"row"} gap={2}>
        {tags.map((tag, idx) => (
          <Chip
            key={idx}
            label={t(tag)}
            sx={{
              background: `linear-gradient(#fff, #fff) padding-box, ${product.tagBorder} border-box`,
              border: "1.5px solid transparent",
              borderRadius: "12px",
              "& .MuiChip-label": {
                fontWeight: 600,
              },
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default Option;
